import { ReactElement } from 'react'
import { Flexbox } from '../../components/flexbox/flexbox'
import { useRecoilValue } from 'recoil'
import { ScreenTitle } from '../../components/screen-title/screen-title'
import ChangePasswordForm from '../../forms/change-password-form'
import { loggedUserState } from '../../states/logged-user-state'

const SecurityScreen = (): ReactElement => {
  const currentUser = useRecoilValue(loggedUserState)

  return (
    <Flexbox isCol flex={1} className="max-w-md">
      <ScreenTitle title={'Security'} />
      Change your current password
      <ChangePasswordForm userId={currentUser?.id} />
    </Flexbox>
  )
}

export default SecurityScreen